import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { settingsApi } from '../api/settings.api'
import type { UserProfile, UpdateProfileRequest } from '../types'

export function useProfile() {
  return useQuery<UserProfile>({
    queryKey: ['settings', 'profile'],
    queryFn: () => settingsApi.getProfile(),
    staleTime: 60_000,
  })
}

export function useUpdateProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (body: UpdateProfileRequest) => settingsApi.updateProfile(body),
    onSuccess: (updatedProfile) => {
      queryClient.setQueryData(['settings', 'profile'], updatedProfile)
    },
  })
}
